$('.best_seller_product').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 5,
  slidesToScroll: 1,
  arrows: true,
  responsive: [
    {
      breakpoint: 1025,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 769,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: "unslick"
    }
  ]
});

$(window).on('resize', function(){
  if ($(window).width() < 500) {
    $('.best_seller_product').slick('unslick');
  }
});

document.addEventListener('click', function (e) {
  const cardInner = e.target.closest('.card__inner');
  if (!cardInner) return;                
  if (e.target.closest('a')) e.preventDefault();
  const tile = cardInner.closest('.grid__item, .card-wrapper, .card');

  if (!tile) {
    console.warn('Product tile not found for', cardInner);
    return;
  }

  const quickAddButton = tile.querySelector('.quick-add__submit');

  if (quickAddButton && !quickAddButton.disabled) {
    quickAddButton.click();
  } else {
    console.warn('Quick-add button not found for', tile);
  }
});


document.addEventListener("DOMContentLoaded", function () {
function toggleFooterOnMobile() {
      if (window.innerWidth <= 1024) { 
        document.querySelectorAll(".open-toggle").forEach(el => el.style.display = "none");
    
        document.querySelectorAll(".menu-toggle").forEach(heading => {
          heading.removeEventListener("click", toggleContent); 
          heading.addEventListener("click", toggleContent);
        });
      } else {
        document.querySelectorAll(".open-toggle").forEach(el => el.style.display = "block");
      }
    }
    
    function toggleContent() {
      let content = this.nextElementSibling;
      
      if (content.style.display === "block") {
        content.style.display = "none";
        this.removeAttribute("open");
      } else {
        content.style.display = "block";
        this.setAttribute("open", "true");
      }
    }
    
    toggleFooterOnMobile();
    window.addEventListener("resize", toggleFooterOnMobile); 
});

